var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"rules":_vm.rules,"name":"email","label":"E-mail","type":"email","autocomplete":"email"}},'v-text-field',_vm.fieldProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }